export default __webpack_public_path__ + "static/media/dark-word.79198704.png";